/**
 * AlphaSense Agent - Evaluation Section
 * Section 5: Final Reminders, Explanations, Evaluation Criteria
 *
 * Keywords AI Key: ALPHASENSE_EVALUATION_CRITERIA
 */
import { PromptSectionBase } from '../../../base/systemPrompt/PromptSectionBase';
import { SECURITY_WARNING_SHORT } from '../../../base/systemPrompt/shared';
import { getSharedVariable } from '../../../../prompts';
import { ALPHASENSE_PROMPT_KEYS } from './variables';
class AlphaSenseEvaluationSection extends PromptSectionBase {
    constructor() {
        super(...arguments);
        this.keywordsKey = ALPHASENSE_PROMPT_KEYS.evaluation;
        this.fallbackContent = `## Example Full Workflow

1. **Batch Search Call**:
\`\`\`json
{
  "queries": [
    { "query": "Apple Q4 2024 revenue", "use_findata_agent": true },
    { "query": "Apple growth guidance 2025", "use_findata_agent": false }
  ]
}
\`\`\`

2. **Submit Results Call**:
\`\`\`json
{
  "results": [
    {
      "requirementId": "A",
      "relevantResults": {
        "searchResults": ["as_7x9kf", "as_m4n8p"]
      },
      "rationale": "Found Q4 2024 revenue breakdown (as_7x9kf) showing $119.6B total revenue and YoY comparison (as_m4n8p) showing 8% growth."
    }
  ],
  "summary": "Found comprehensive data from earnings call transcripts"
}
\`\`\`

---

## Evaluation Criteria

Your performance is evaluated on:

### Search Quality
- Did you formulate effective search queries?
- Did you use batch queries efficiently?
- Did you select appropriate use_findata_agent settings?

### Result Relevance
- Do the selected chunks address the requirements?
- Is the data accurate and from reliable sources?
- Did you include sufficient context without token bloat?

### Completeness
- Did you address ALL requirements?
- Are there any gaps in the data that should be noted?
- Did you call submitResults with proper structure?

---

## Final Reminders

1. **ALWAYS use submitResults** - Never just respond with text
2. **BATCH your queries** - Multiple queries = same execution time
3. **Include chunk IDs** - Use the as_xxx contextIds in your results
4. **Write good rationales** - Explain what you found and why it's relevant

${SECURITY_WARNING_SHORT}`;
    }
}
const evaluationSection = new AlphaSenseEvaluationSection();
/**
 * Get the evaluation section.
 * Uses Keywords AI if available, otherwise falls back to code.
 * Supports {{securityWarnings}} variable replacement.
 */
export function getEvaluationSection() {
    return evaluationSection.getContentWithVariables({
        securityWarnings: getSharedVariable('securityWarnings'),
    });
}
/**
 * Export constant for backwards compatibility
 */
export const ALPHASENSE_EVALUATION = evaluationSection.getFallbackContent();
